import numeral from 'numeral';
import Vue from 'vue';
import {parsePhoneNumberFromString} from "libphonenumber-js";

Vue.filter( "displayPhone", function( value ){
    if( _.isString( value ) ){
        const phoneNumber = parsePhoneNumberFromString( value, 'US' );

        if( phoneNumber && phoneNumber.isValid() ){
            return phoneNumber.formatNational();
        }
        else {
            return value;
        }
    }
} );

Vue.filter( "displayCurrency", function( value ){
    if( _.isNumber( value ) ){
        let numeralValue = numeral( value );
        let formattedValue = numeralValue.format( '0,0.00' );

        if( _.isString( formattedValue ) ){
            return '$' + formattedValue.substring( 0, formattedValue.length - 3 ) +
                '<sup>' + formattedValue.substring( formattedValue.length - 3, formattedValue.length ) + '</sup>';
        }
    }
} );

Vue.filter( "displayCurrencyCents", function( value ){
    if( _.isNumber( value ) ){
        let numeralValue = numeral( value / 100 );
        let formattedValue = numeralValue.format( '0,0.00' );

        if( _.isString( formattedValue ) ){
            return '$' + formattedValue.substring( 0, formattedValue.length - 3 ) +
                '<sup>' + formattedValue.substring( formattedValue.length - 3, formattedValue.length ) + '</sup>';
        }
    }
} );

Vue.filter( "date", function( value ){
    // For date only strings use local value
    if( _.isString( value ) && value.length === 10 ){
        return moment( value ).local().format( 'MMM, Do YYYY' );
    }
    // for datetime strings use utc().local()
    else if( value ){
        return moment.utc( value ).local().format( 'MMM, Do YYYY' );
    }
} );

Vue.filter( "titleCase", function( value ){
    return _.startCase( value );
} );